import { httpGet, httpGet_New } from './api.service';
import { GetStationRequest } from '../requestModels/getStationRequest';
import { Result } from '../types/Result';
import { BasicStation, Station, StationResponse } from '../types/Station';
import { PaginatedResult } from '../types/PaginatedResult';
import { SingleResult } from '../types/SingleResult';

export const getStations = async (request: GetStationRequest): Promise<SingleResult<PaginatedResult<StationResponse>>> =>
  await httpGet<SingleResult<PaginatedResult<StationResponse>>>(`api/station`, request);

export const getAllStations = async (params: Record<string, string | number>) => {
  const stringParams = Object.fromEntries(Object.entries(params).map(([key, value]) => [key, String(value)]));
  const queryString = new URLSearchParams(stringParams).toString();

  return await httpGet<SingleResult<PaginatedResult<StationResponse>>>(`api/station?${queryString}`);
};

export const getStationById = async (id: string): Promise<Result<Station>> => await httpGet<Result<Station>>(`api/station/${id}`);

export const searchBasicStations = async (query: string): Promise<BasicStation[]> => await httpGet_New<BasicStation[]>(`api/station/search/${query}`);
